import React from "react";
import "./App.css";

import "react-credit-cards/es/styles-compiled.css";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
  checkIfFieldsAreInvalid,
  formatRequiredStrings,
  assembleBodyRequest,
  formatCNPJ,
  formatCPF,
  validateEmail
/*   formatReal, */
} from "./utils";
import swal from "@sweetalert/with-react";
import cep from "cep-promise";
import { cnpj, cpf } from "cpf-cnpj-validator";
import Receipt from "./Components/UserFeedback/Receipt";
import Logo from "./Components/Basics/Logo";
import Receiver from "./Components/PaymentData/Receiver";
import Data from "./Components/PaymentData/Data";
import Address from "./Components/FormGroups/Address";
import Card from "./Components/FormGroups/Card";
import { v4 as uuidv4 } from "uuid";

class App extends React.Component {
  initial = {
    nameInvalid: false,
    numberInvalid: false,
    expiryInvalid: false,
    securityCodeInvalid: false,
    error: null,
    fatal: null,
    receipt: null,
    checkoutRunning: false,
    forbbiden: false,
    showReceipt: false,
  };

  initialFields = {
    type_document: "CPF",
    document_number: "",
    name: "",
    number: "",
    expiry: "",
    cvc: "",
    issuer: "",
    focused: "",
    formData: null,
    phone_number: "",
    email: "",

    postal_code: "",
    postal_code_verified: false,
    street: "",
    number_address: "",
    neighborhood: "",
    state_code: "",
    city: "",
  };

  state = {
    ip_address: null,
    session_id: "",
    loading: true,
    billing: {},
    criptogram: null,
    ...this.initialFields,
    ...this.initial,
  };

  componentWillMount() {}

  componentDidMount() {
    let UiiId = uuidv4();
    this.addTagScript(UiiId);
    const params = new URLSearchParams(window.location.search);

    fetch("https://api.ipify.org/?format=json")
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        let ip = json.ip;
        this.setState({ ip_address: ip });
      });

    /* .then((json) => console.log(json)); */

    var billingCryptogram = params.get("checkout");
    if (billingCryptogram === null) {
      billingCryptogram = window.location.pathname
        .replace("/", "")
        .replace("pay/", "");
    }
    if (!billingCryptogram) {
      this.setState({ fatal: "Página foi aberta sem um checkout associado" });
    } else {
      fetch(
        `${process.env.REACT_APP_URL_GATEWAY}/v1/links/checkout/${billingCryptogram}`,
        { credentials: "same-origin" }
      )
        .then((res) => this.checkResponse(res))
        .then((res) => {
          return res.json();
        })
        .then((msg) => {
          this.setState({
            billing: msg,
            criptogram: billingCryptogram,
            loading: false,
          });
        })
        .catch((error) => this.handleError(error));
    }
  }

  addTagScript(UiiId) {
    const script = document.createElement("script");
    let orgId = "";

    if (process.env.NODE_ENV === "development") {
      // 1snn5n9w Ambiente sandbox
      orgId = "1snn5n9w";
      script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=propig_br${UiiId}`;
    } else {
      //k8vif92e Ambiente de produção
      orgId = "k8vif92e";
      script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=propig_br${UiiId}`;
    }
    this.setState({session_id: UiiId})
    script.async = true;
    document.body.appendChild(script);
  }

  getCep() {
    const { postal_code } = this.state;
    if (postal_code.length === 9) {
      cep(postal_code)
        .then((res) => {
          this.setState({
            state_code: res.state,
            city: res.city,
            street: res.street,
            neighborhood: res.neighborhood,
            postal_code: res.cep,
            postal_code_verified: true
          });
        })
        .catch((error) => {
          this.setState({
            postal_code: postal_code + " ",
            postal_code_verified: false
          })
          swal("Ops!", "CEP não encontrado", "error");
        });
    }
  }

  handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      this.setState({ issuer });
    }
  };

  handleInputFocus = ({ target }) => {
    this.setState({
      focused: target.name,
    });
  };

  handleInputChange = ({ target }) => {
    const { type_document } = this.state;
    if (target.name === "number") {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === "expiry") {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === "cvc") {
      target.value = formatCVC(target.value);
    } else if (target.name === "document_number") {
      if (type_document === "CPF") {
        if (target.value.length === 14) {
          if (!cpf.isValid(target.value)) swal("Ops!", "CPF inválido", "error");
        }
      } else if (type_document === "CNPJ") {
        if (target.value.length === 18) {
          if (!cnpj.isValid(target.value))
            swal("Ops!", "CNPJ inválido", "error");
        }
      }
    }

    this.setState({ [target.name]: target.value });
  };

  handleCheckout() {
    const {
      name,
      number,
      expiry,
      cvc,
      criptogram,
      document_number,
      type_document,
      issuer,
      street,
      number_address,
      neighborhood,
      city,
      state_code,
      postal_code,
      billing,
      ip_address,
      session_id,
      email,
      phone_number,
    } = this.state;
    const card_data = {
      name,
      number,
      expiry,
      cvc,
      document_number,
      type_document,
      issuer,
    };
    const address_data = {
      street,
      number_address,
      neighborhood,
      city,
      state_code,
      postal_code,
      phone_number,
      email,
    };

    const value = billing.amount * 1;
    const valor_pagamento = value.toLocaleString('pt-BR', { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 })

    

    if (checkIfFieldsAreInvalid(card_data, address_data)) {
      swal("Ops!", "Por favor, preencha todos os dados", "error");
    } else if (!this.state.postal_code_verified) {
      swal("Ops!", "Não foi possível verificar o CEP informado", "error");
    } else {
      if (validateEmail(address_data.email)) {
        swal({
          title: "Confirmação de pagamento",
          text: `Eu ${card_data.name}, portador do ${type_document} de nº ${document_number} e do cartão de nº ${card_data.number}, autorizo o faturamento para ${billing.nome_lojista} referente à compra${billing.descricao_cliente ? ' de ' + billing.descricao_cliente : ''} no valor de R$ ${valor_pagamento} a ser pago em ${billing.installments} parcela(s).`,
          buttons: {
            cancel: "Cancelar",
            ok: {
              text: "Continuar",
              value: "ok",
            },
          },
        }).then(async (value) => {
          switch (value) {
            case "ok":
              // termos aceitos
              await this.acceptTerms(billing, card_data);
              console.log("termos aceitos")

              // fluxo de pagamento
                if (billing.recurrent_payment) {
                  swal({
                    title: "Atenção!",
                    text: "Este link de pagamento irá gerar uma cobrança recorrente!",
                    buttons: {
                      cancel: "Cancelar",
                      ok: {
                        text: "Continuar",
                        value: "ok",
                      },
                    },
                  }).then((value) => {
                    switch (value) {
                      case "ok":
                        this.sendRequest(
                          card_data,
                          address_data,
                          expiry,
                          number,
                          billing,
                          email,
                          name,
                          criptogram,
                          ip_address,
                          session_id
                        );
                        break;
                      default:
                        break;
                    }
                  });
                } else {
                  this.sendRequest(
                    card_data,
                    address_data,
                    expiry,
                    number,
                    billing,
                    email,
                    name,
                    criptogram,
                    ip_address,
                    session_id
                  );
                }
              break;


            default:
              break;
            }
        })
      } else {
        swal("Ops!", "Por favor, insira um email válido", "error");
      }
    }
  }

  async acceptTerms(billing, card_data) {
    await fetch(`${process.env.REACT_APP_URL_API}/payment-link/terms`, {
        method: 'POST', body: JSON.stringify({
          "paymentLinkId": billing.id,
          "cardHolder": card_data.name
        }), headers: { 'Content-Type': 'application/json', }
      }
    )
  }

  sendRequest(
    card_data,
    address_data,
    expiry,
    number,
    billing,
    email,
    name,
    criptogram,
    ip_address,
    session_id
  ) {
    const formatedCardStrings = formatRequiredStrings(expiry, number);
    const options = assembleBodyRequest(
      formatedCardStrings,
      card_data,
      address_data,
      billing,
      ip_address,
      session_id
    );
    this.setState({ ...this.initial, checkoutRunning: true });
    fetch(`${process.env.REACT_APP_URL_GATEWAY}/v1/pagamentos/pay`, options)
      .then((res) => this.checkResponse(res))
      .then((res) => res.json())
      .then((msg) => {
        this.setState({
          ...this.initial,
          ...this.initialFields,
          name: name,
          email: email,
          receipt: msg,
          showReceipt: true,
        });
      })
      .catch((error) => this.handleError(error));
  }

  checkResponse(response) {
    if (!response.ok) {
      if (response.status === 403) {
        this.setState({
          ...this.initial,
          ...this.initialFields,
          forbbiden: true,
        });
      }
      throw new Error(response.statusText);
    }
    return response;
  }

  handleCloseReceipt() {
    this.setState({ showReceipt: false });
  }

  handleError(error, fatal) {
    this.setState({ checkoutRunning: false });
    swal(
      error.message,
      "Ops! Houve um problema com a transação. Por favor, tente novamente.",
      "error"
    );
  }

  formatDocument(value) {
    if (value) {
      if (value.length > 11) return formatCNPJ(value);
      else return formatCPF(value);
    }
  }

  checkRecurrence() {
    swal({
      title: "Atenção!",
      text: "Este link de pagamento irá gerar uma cobrança recorrente!",
      buttons: {
        cancel: "Cancelar",
        ok: {
          text: "Continuar",
          value: "ok",
        },
      },
    }).then((value) => {
      switch (value) {
        case "ok":
          swal("Pikachu fainted! You gained 500 XP!");
          break;
        default:
          break;
      }
    });
  }

  render() {
    const {
      focused,
      type_document,
      name,
      number,
      expiry,
      cvc,
      fatal,
      checkoutRunning,
      billing,
      forbbiden,
      postal_code,
      street,
      number_address,
      phone_number,
      email,
      neighborhood,
      state_code,
      document_number,
      city,
      loading,
      receipt,
      showReceipt,
    } = this.state;

    const value = billing.amount * 1; // Investigar sem uma operação matematica, billing vem undefined
     const valor_pagamento = value.toLocaleString('pt-BR', { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 })
    /* const valor_pagamento = value ? formatReal(value, "amount") : ""; */
    const valor_por_parcela = billing.amount_per_installment * 1;
    const valor_por_parcela_formatada = valor_por_parcela.toLocaleString('pt-BR', { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 })
    /* const valor_por_parcela_formatada =
      billing.installments === 1
        ? "À vista"
        : valor_por_parcela && billing.installments !== 1
        ? formatReal(value, "installments", billing.installments)
        : "Não foi possível carregar nº de parcelas"; */
    const parcela_valor = valor_por_parcela_formatada;
    const documentoFormatado = this.formatDocument(billing.client_document);

    if (fatal)
      return (
        <div className="container p-4 text-center">
          <h4 className="text-danger">{fatal}</h4>{" "}
        </div>
      );
    if (forbbiden)
      return (
        <div className="container p-4 text-center">
          <h4 className="text-danger">Você não tem acesso a essa página</h4>{" "}
        </div>
      );
    return (
      <div className="container mt-4">
        <Logo img="https://imagens-propig.propig.com.br/images/credmoura/credmoura-logo.png"/>
        <Receiver
          loading={loading}
          nome_lojista={billing.nome_lojista}
          documento_lojista={documentoFormatado}
        />

        <div className="row mt-3">
          <div className="col-md-6">
            <Data
              loading={loading}
              titulo={billing.title}
              valor_pagamento={valor_pagamento}
              parcelas={billing.installments}
              valor_por_parcela={parcela_valor}
              recurrent_payment={billing.recurrent_payment}
              recurrence_type={billing.recurrence_type}
              descricao_cliente={billing.descricao_cliente}
            />

            <Address
              onBlur={this.getCep()}
              onChange={this.handleInputChange}
              postal_code={postal_code}
              street={street}
              number_address={number_address}
              neighborhood={neighborhood}
              state_code={state_code}
              city={city}
            />
          </div>
          <div className="col-md-6">
            <Card
              cvc={cvc}
              expiry={expiry}
              focused={focused}
              name={name}
              number={number}
              phone_number={phone_number}
              email={email}
              handleCallback={this.handleCallback}
              handleInputChange={this.handleInputChange}
              handleInputFocus={this.handleInputFocus}
              type_document={type_document}
              document_number={document_number}
              checkoutRunning={checkoutRunning}
              handleCheckout={(e) => this.handleCheckout(e)}
            />
            <div className="row mt-4">
              <div className="col-md-12">
                <label className="float-right" style={{ color: "#a8a2a2" }}>
                  {process.env.REACT_APP_VERSION}{" "}
                </label>
              </div>
            </div>
          </div>
        </div>
        {receipt ? (
          <Receipt
            receipt={receipt}
            customer_name={name}
            email={email}
            phone_number={phone_number}
            showReceipt={showReceipt}
            handleClose={() => this.handleCloseReceipt()}
          />
        ) : null}
      </div>
    );
  }
}

export default App;
